import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var Event = /*#__PURE__*/function () {
  function Event() {
    _classCallCheck(this, Event);
    this._listeners = new Set();
    this._effects = new Set();
  }
  _createClass(Event, [{
    key: "emit",
    value: function emit(data) {
      for (var _i = 0, _Array$from = Array.from(this._listeners); _i < _Array$from.length; _i++) {
        var listener = _Array$from[_i];
        void this._trigger(listener, data);
      }
    }
  }, {
    key: "on",
    value: function on(callback) {
      var _this = this;
      this._listeners.add(callback);
      if (this.listenerCount() === 1) {
        this._runEffects();
      }
      return function () {
        return _this.off(callback);
      };
    }
  }, {
    key: "off",
    value: function off(callback) {
      this._listeners.delete(callback);
      if (this.listenerCount() === 0) {
        this._cleanupEffects();
      }
    }
  }, {
    key: "listenerCount",
    value: function listenerCount() {
      return this._listeners.size;
    }
  }, {
    key: "addEffect",
    value: function addEffect(effect) {
      var _this2 = this;
      var handle = {
        effect: effect,
        cleanup: undefined
      };
      if (this.listenerCount() > 0) {
        var cleanup = handle.effect();
        if (typeof cleanup === 'function') {
          handle.cleanup = cleanup;
        }
      }
      this._effects.add(handle);
      return function () {
        var _a;
        // eslint-disable-next-line no-unused-expressions
        (_a = handle.cleanup) === null || _a === void 0 ? void 0 : _a.call(handle);
        _this2._effects.delete(handle);
      };
    }
  }, {
    key: "_trigger",
    value: function () {
      var _trigger2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(listener, data) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return waitImmediate();
            case 3:
              // Acts like setImmediate but preserves the stack-trace.
              listener(data);
              _context.next = 9;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              // Stop error propagation.
              throwUnhandledRejection(_context.t0);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 6]]);
      }));
      function _trigger(_x, _x2) {
        return _trigger2.apply(this, arguments);
      }
      return _trigger;
    }()
  }, {
    key: "_runEffects",
    value: function _runEffects() {
      for (var _i2 = 0, _Array$from2 = Array.from(this._effects); _i2 < _Array$from2.length; _i2++) {
        var handle = _Array$from2[_i2];
        var cleanup = handle.effect();
        if (typeof cleanup === 'function') {
          handle.cleanup = cleanup;
        }
      }
    }
  }, {
    key: "_cleanupEffects",
    value: function _cleanupEffects() {
      var _a;
      for (var _i3 = 0, _Array$from3 = Array.from(this._effects); _i3 < _Array$from3.length; _i3++) {
        var handle = _Array$from3[_i3];
        // eslint-disable-next-line no-unused-expressions
        (_a = handle.cleanup) === null || _a === void 0 ? void 0 : _a.call(handle);
        handle.cleanup = undefined;
      }
    }
  }]);
  return Event;
}();
function throwUnhandledRejection(error) {
  setTimeout(function () {
    throw error;
  });
}
/**
 * Like setImmediate but for async/await API. Useful for preserving stack-traces.
 */
var waitImmediate = function waitImmediate() {
  return new Promise(function (resolve) {
    return setTimeout(resolve);
  });
};